/**
 * Export `contacts`.
 */

export const contacts = {
  address: 'Estrada Nacional 206, KM38\n4805-026 Brito, Guimarães\nPortugal',
  email: 'sales@amtrol-alfa.com',
  emailHR: 'rh-geral@amtrol-alfa.com',
  fax: '+351 253 531 527',
  gpsCoordinates: {
    latitude: '41.4465',
    longitude: '-8.35703'
  },
  phone: '+351 253 540 200',
  whatsapp: '+351 938 131 591'
};
